import React from 'react';
import PropTypes from 'prop-types';

import { VerticalRhythm } from 'mage-components';
import { SpacerVertical } from '@klarna/bubble-ui';

import { tPrefix } from '@/components/DocumentUpload/constants';

import { DocumentsHeader } from './DocumentsHeader';
import { DocumentsBlock } from './DocumentsBlock';

export const BusinessDocuments = ({ uploadedDocuments = [], documentRequirements = [], t }) => (
  <>
    <SpacerVertical small />
    <DocumentsHeader title={t(`${tPrefix}.business_documents`)} />
    <SpacerVertical small />
    <DocumentsBlock
      documentRequirements={documentRequirements}
      uploadedDocuments={uploadedDocuments}
    />
    <VerticalRhythm spacing={{ mobile: 5, tablet: 5, desktop: 8 }} />
  </>
);

BusinessDocuments.propTypes = {
  t: PropTypes.func.isRequired,
  documentRequirements: PropTypes.array,
  uploadedDocuments: PropTypes.array,
};
